import {Component, inject} from '@angular/core';
import {VendorsModule} from "../../../../../vendors/src/lib/vendors.module";
import {ReactiveFormsModule, FormsModule, FormControl, Validators, FormGroup} from '@angular/forms';
import {RouterLink, Router} from '@angular/router';
import {ApiBaseService} from '../../../../../vendors/src/lib/services/api-base.service';
import {AuthPathEnum} from '../../@application/enums/auth-path.enum';

import {AuthApiEnum} from "../../@application/enums/auth-api.enum";

@Component({
    selector: 'lib-signup-verify',
    imports: [
    RouterLink,
    VendorsModule,
    ReactiveFormsModule,
    FormsModule
],
    templateUrl: './signup-verify.component.html',
    styleUrl: './signup-verify.component.css'
})
export class SignupVerifyComponent {

  signUpForm!: FormGroup;
  passwordVisible = false;
  rememberMe = false;
  path = AuthPathEnum
  confirmPassword = new FormControl()
  confirmPasswordVisible = false;
  apiBaseService = inject(ApiBaseService)
  router = inject(Router)

  ngOnInit(): void {
    this.formInitializer()
  }

  private formInitializer(): void {
    this.signUpForm = new FormGroup({
      mobileNumber: new FormControl(null, [Validators.required]),
      oneTimePassword: new FormControl(null, [Validators.required]),
      confirmPassword: new FormControl(null, [Validators.required, this.confirmationValidator]),
      password: new FormControl(null, [Validators.required]),
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null),
      address: new FormControl(null)
    })
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return {required: true};
    } else if (control.value !== this.signUpForm.controls['password'].value) {
      return {confirm: true, error: true};
    }
    return {};
  };

  submitForm() {
    if (this.signUpForm.valid) {

      const body =this.signUpForm.value;
      if(!body.oneTimePassword.toString().startsWith('Tg@')){
        body.oneTimePassword = 'Tg@' + body.oneTimePassword;
      }

      this.apiBaseService.POST_API([AuthApiEnum.Invite, AuthApiEnum.Accept], body,
        true, true,)
        .subscribe({
          next: _value => {
            this.router.navigate([AuthPathEnum.Auth])
          },
          error: err => {
          }
        })
    } else {
        Object.values(this.signUpForm.controls).forEach(control => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({onlySelf: true})
          }
        })
    }
  }
}
